import React from 'react';
import './About.css';
import aboutImage from '../../assets/images/creations/home_decor/pillow.png';

function About(): React.ReactElement {
  return (
    <section className="about" id="about">
      <div className="about-inner">
        <div className="about-content">
          <span className="about-badge">Handmade with love</span>
          <h2 className="about-title">Welcome to Trupz Looplet</h2>
          <p className="about-lead">
          Discover beautifully handcrafted pieces made with love, care, and attention to detail. Each design is created to bring warmth, comfort, and a touch of joy into your everyday life.          </p>
          <a href="#creations" className="about-cta">Explore Collections</a>
        </div>
        <div className="about-image">
          <img src={aboutImage} alt="Handcrafted crochet pillow" />
        </div>
      </div>
    </section>
  );
}

export default About;
